import React from 'react'

import logo from '../assets/images/intelllex-reversed-logo.png'
import externalLinkSvg from '../assets/icons/external-link.svg'

const Header = ({ tall }) => (
  <div className="header">
    <div className="header-row">
      <span className="logo-group">
        <img src={logo} className="logo" />
        <span>INTELLLEX</span>
      </span>
      <h3 className="support">SUPPORT</h3>
      <a href="https://intelllex.com" className="intlx-link">
        <img src={externalLinkSvg} />
        Back to INTELLLEX
      </a>
    </div>
    {tall &&
      <h1 className="caption">Get more out of INTELLLEX</h1>
    }
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js